module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/desk/desk.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/desk/desk.png
// module id = 551
// module chunks = 0